import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { MdClose } from 'react-icons/md';
import * as Dialog from '@radix-ui/react-dialog';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';
import NextImage from 'next/image';
import { useRouter } from 'next/navigation';
import AuthContext from '../../../context/AuthContext';
import buildRouteUrl from '../../../helpers/buildRouteUrl';
import isStringEmpty from '../../../helpers/isStringEmpty';
import useModal from '../../../hooks/useModal';
import { Link } from '../../../i18n/navigation';
import { Episode } from '../../../types/types';
import WatchedButton from '../../WatchedButton';
interface PropTypes {
  data: Episode;
  isPreviousEpisodeWatched: string;
  onMarkAsWatched(params: number): void;
  onUnmarkAsWatched(params: number): void;
  onMarkPreviousEpisodesAsWatched(params: number): void;
  onRewatch?: (event?: React.MouseEvent<HTMLElement>) => void;
  onResetWatches?: (event?: React.MouseEvent<HTMLElement>) => void;
  onResetRewatches?: (event?: React.MouseEvent<HTMLElement>) => void;
  className?: string;
}
function EpisodeItem(t0) {
  const $ = _c(113);
  const {
    data,
    isPreviousEpisodeWatched,
    onMarkAsWatched,
    onUnmarkAsWatched,
    onMarkPreviousEpisodesAsWatched,
    onRewatch,
    onResetWatches,
    onResetRewatches,
    className
  } = t0;
  useRouter();
  const auth = useContext(AuthContext);
  const t = useTranslations();
  const {
    isOpen,
    onOpen,
    onClose
  } = useModal();
  const seasonNumber = data.season_number < 10 ? "0" + data.season_number : data.season_number;
  const episodeNumber = data.episode_number < 10 ? "0" + data.episode_number : data.episode_number;
  let t1;
  if ($[0] !== data.air_date) {
    const today = dayjs(new Date());
    const airDate = dayjs(new Date(data.air_date));
    t1 = airDate.diff(today, "days");
    $[0] = data.air_date;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const missingDaysToRelease = t1;
  let t2;
  if ($[2] !== data.episode_number || $[3] !== data.season_number || $[4] !== data.user_related?.is_watched || $[5] !== isPreviousEpisodeWatched || $[6] !== onMarkAsWatched || $[7] !== onOpen || $[8] !== onUnmarkAsWatched) {
    t2 = function handleMarkEpisodeAsWatchedPress() {
      if (!data?.user_related?.is_watched) {
        const previousEpisodeExists = !(data.season_number === 1 && data.episode_number === 1);
        if (previousEpisodeExists && isPreviousEpisodeWatched === "not_watched") {
          onOpen();
        } else {
          onMarkAsWatched(data.episode_number);
        }
      } else {
        onUnmarkAsWatched(data.episode_number);
      }
    };
    $[2] = data.episode_number;
    $[3] = data.season_number;
    $[4] = data.user_related?.is_watched;
    $[5] = isPreviousEpisodeWatched;
    $[6] = onMarkAsWatched;
    $[7] = onOpen;
    $[8] = onUnmarkAsWatched;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleMarkEpisodeAsWatchedPress = t2;
  let t3;
  if ($[10] !== onClose) {
    t3 = isOpen_0 => {
      if (!isOpen_0) {
        onClose();
      }
    };
    $[10] = onClose;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t) {
    t4 = t("tv_show.mark_previous_episodes_as_watched_modal.title");
    $[12] = t;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <span className="text-white font-bold text-2xl">{t4}</span>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MdClose size="28" />;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== onClose) {
    t7 = <button className="text-white" onClick={onClose}>{t6}</button>;
    $[17] = onClose;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t7) {
    t8 = <div className="flex flex-row justify-between items-center">{t5}{t7}</div>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== data.episode_number || $[23] !== onClose || $[24] !== onMarkPreviousEpisodesAsWatched) {
    t9 = () => {
      onMarkPreviousEpisodesAsWatched(data.episode_number);
      onClose();
    };
    $[22] = data.episode_number;
    $[23] = onClose;
    $[24] = onMarkPreviousEpisodesAsWatched;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t) {
    t10 = t("confirmation_modal.yes");
    $[26] = t;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t9) {
    t11 = <button className="h-[40px] bg-red-600 hover:bg-red-500 text-white rounded-md px-4 font-bold mr-2" onClick={t9}>{t10}</button>;
    $[28] = t10;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== data.episode_number || $[32] !== onClose || $[33] !== onMarkAsWatched) {
    t12 = () => {
      onMarkAsWatched(data.episode_number);
      onClose();
    };
    $[31] = data.episode_number;
    $[32] = onClose;
    $[33] = onMarkAsWatched;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t) {
    t13 = t("confirmation_modal.no");
    $[35] = t;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t12 || $[38] !== t13) {
    t14 = <button className="h-[40px] bg-white hover:bg-gray-100 text-black rounded-md px-4 font-bold" onClick={t12}>{t13}</button>;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t11 || $[41] !== t14) {
    t15 = <div className="flex flex-row mt-4">{t11}{t14}</div>;
    $[40] = t11;
    $[41] = t14;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t15 || $[44] !== t8) {
    t16 = <Dialog.Portal><Dialog.Overlay className="flex justify-center items-center fixed inset-0 bg-[rgba(0,0,0,0.7)] bg-opacity-25 transition-opacity z-10 px-2"><Dialog.Content className="w-full md:w-[500px] bg-gray-600 rounded-md p-4">{t8}{t15}</Dialog.Content></Dialog.Overlay></Dialog.Portal>;
    $[43] = t15;
    $[44] = t8;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== isOpen || $[47] !== t16 || $[48] !== t3) {
    t17 = <Dialog.Root open={isOpen} onOpenChange={t3}>{t16}</Dialog.Root>;
    $[46] = isOpen;
    $[47] = t16;
    $[48] = t3;
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  const t18 = `flex flex-col justify-between ${className}`;
  const t19 = `/episode/${data._id}`;
  let t20;
  if ($[50] !== t19) {
    t20 = buildRouteUrl(t19);
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  const t21 = `w-full rounded-md bg-gray-400 cursor-pointer aspect-video transition-all duration-200 hover:opacity-30 ${data.wallpaper ? "opacity-60" : "opacity-100"}`;
  const t22 = data.wallpaper ? `https://cdn-proxy.trakio.app/t/p/w400${data?.wallpaper?.file_path}` : "/assets/app/wallpaper-fallback.jpg";
  let t23;
  if ($[52] !== episodeNumber || $[53] !== seasonNumber || $[54] !== t) {
    t23 = t("common.episode_season_tag", {
      season: seasonNumber,
      episode: episodeNumber
    });
    $[52] = episodeNumber;
    $[53] = seasonNumber;
    $[54] = t;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  const t24 = `${data.tv?.title} Episode ${t23} Wallpaper`;
  let t25;
  if ($[56] !== t21 || $[57] !== t22 || $[58] !== t24) {
    t25 = <img className={t21} src={t22} alt={t24} />;
    $[56] = t21;
    $[57] = t22;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== t20 || $[61] !== t25) {
    t26 = <Link className="font-bold text-white text-sm cursor-pointer w-full h-full self-start" href={t20}>{t25}</Link>;
    $[60] = t20;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  let t27;
  if ($[63] !== auth.isLoadingSubscription || $[64] !== auth.isLoggedIn || $[65] !== auth.userSubscription?.status || $[66] !== data.air_date || $[67] !== data.released || $[68] !== data.user_related || $[69] !== handleMarkEpisodeAsWatchedPress || $[70] !== missingDaysToRelease || $[71] !== onResetRewatches || $[72] !== onResetWatches || $[73] !== onRewatch || $[74] !== t) {
    t27 = auth.isLoggedIn && data.user_related && <>{!data.released ? data.air_date ? <span className="text-white text-sm font-bold uppercase">{missingDaysToRelease}{" "}{t("tv_show.episodes.episode.days")}</span> : <span className="text-gray-200 text-sm font-bold">TBD</span> : <>{!auth.isLoadingSubscription && <>{auth.userSubscription?.status !== "active" && <WatchedButton btnType="icon" isWatched={data.user_related.is_watched} onClick={handleMarkEpisodeAsWatchedPress} />}{auth.userSubscription?.status === "active" && !data.user_related.is_watched && <WatchedButton btnType="icon" isWatched={data.user_related.is_watched} onClick={handleMarkEpisodeAsWatchedPress} />}{auth.userSubscription?.status === "active" && data.user_related.is_watched && <WatchedButton watchCount={data.user_related.watch_count} btnType="icon" withOptions={true} isWatched={data.user_related.is_watched} onRewatch={onRewatch} onResetWatches={onResetWatches} onResetRewatches={onResetRewatches} />}</>}</>}</>;
    $[63] = auth.isLoadingSubscription;
    $[64] = auth.isLoggedIn;
    $[65] = auth.userSubscription?.status;
    $[66] = data.air_date;
    $[67] = data.released;
    $[68] = data.user_related;
    $[69] = handleMarkEpisodeAsWatchedPress;
    $[70] = missingDaysToRelease;
    $[71] = onResetRewatches;
    $[72] = onResetWatches;
    $[73] = onRewatch;
    $[74] = t;
    $[75] = t27;
  } else {
    t27 = $[75];
  }
  let t28;
  if ($[76] !== t27) {
    t28 = <div className="absolute bottom-2 right-2">{t27}</div>;
    $[76] = t27;
    $[77] = t28;
  } else {
    t28 = $[77];
  }
  let t29;
  if ($[78] !== t26 || $[79] !== t28) {
    t29 = <div className="bg-gray-400 rounded-md aspect-video relative">{t26}{t28}</div>;
    $[78] = t26;
    $[79] = t28;
    $[80] = t29;
  } else {
    t29 = $[80];
  }
  const t30 = `/episode/${data._id}`;
  let t31;
  if ($[81] !== t30) {
    t31 = buildRouteUrl(t30);
    $[81] = t30;
    $[82] = t31;
  } else {
    t31 = $[82];
  }
  let t32;
  if ($[83] !== episodeNumber || $[84] !== seasonNumber || $[85] !== t) {
    t32 = t("common.episode_season_tag", {
      season: seasonNumber,
      episode: episodeNumber
    });
    $[83] = episodeNumber;
    $[84] = seasonNumber;
    $[85] = t;
    $[86] = t32;
  } else {
    t32 = $[86];
  }
  let t33;
  if ($[87] !== t31 || $[88] !== t32) {
    t33 = <Link className="font-bold text-white text-sm cursor-pointer self-start hover:opacity-[0.5]" href={t31}>{t32}</Link>;
    $[87] = t31;
    $[88] = t32;
    $[89] = t33;
  } else {
    t33 = $[89];
  }
  const t34 = `/episode/${data._id}`;
  let t35;
  if ($[90] !== t34) {
    t35 = buildRouteUrl(t34);
    $[90] = t34;
    $[91] = t35;
  } else {
    t35 = $[91];
  }
  let t36;
  if ($[92] !== data.name || $[93] !== t35) {
    t36 = <Link className="font-bold text-white text-sm cursor-pointer line-clamp-2 self-start hover:opacity-[0.5]" href={t35}>{data.name}</Link>;
    $[92] = data.name;
    $[93] = t35;
    $[94] = t36;
  } else {
    t36 = $[94];
  }
  let t37;
  if ($[95] !== data.overview || $[96] !== t) {
    t37 = !isStringEmpty(data.overview) ? data.overview : t("tv_show.episodes.episode.no_overview_available");
    $[95] = data.overview;
    $[96] = t;
    $[97] = t37;
  } else {
    t37 = $[97];
  }
  let t38;
  if ($[98] !== t37) {
    t38 = <p className="text-[#a3a3a3] text-sm line-clamp-5 mt-1">{t37}</p>;
    $[98] = t37;
    $[99] = t38;
  } else {
    t38 = $[99];
  }
  let t39;
  if ($[100] !== t33 || $[101] !== t36 || $[102] !== t38) {
    t39 = <div className="flex flex-row justify-between w-full mt-2 flex-wrap md:flex-nowrap"><div className="flex flex-col">{t33}{t36}{t38}</div></div>;
    $[100] = t33;
    $[101] = t36;
    $[102] = t38;
    $[103] = t39;
  } else {
    t39 = $[103];
  }
  let t40;
  if ($[104] !== t29 || $[105] !== t39) {
    t40 = <div className="flex flex-col">{t29}{t39}</div>;
    $[104] = t29;
    $[105] = t39;
    $[106] = t40;
  } else {
    t40 = $[106];
  }
  let t41;
  if ($[107] !== t18 || $[108] !== t40) {
    t41 = <div className={t18}>{t40}</div>;
    $[107] = t18;
    $[108] = t40;
    $[109] = t41;
  } else {
    t41 = $[109];
  }
  let t42;
  if ($[110] !== t17 || $[111] !== t41) {
    t42 = <>{t17}{t41}</>;
    $[110] = t17;
    $[111] = t41;
    $[112] = t42;
  } else {
    t42 = $[112];
  }
  return t42;
}
export default EpisodeItem;